
<div
  *ngIf="type === 'block'"
  class="skeleton-element block"
  aria-hidden="true"
  [ngClass]="additionalElementClasses"
  [ngStyle]="{
    borderRadius: getItemDimension(borderRadius)
  }"
>
</div>

<span 
    *ngIf="type === 'text'"
    class="skeleton-element text"
    aria-hidden="true"
    [ngClass]="additionalElementClasses">{{"_".repeat(symbolsCount)}}</span>